import { QueryOptions } from '@tanstack/react-query';
import { TimeoutError } from 'ky';

type QueryRetriesStrategies = {
  retryTimeout: QueryOptions['retry'];
};

export const queryRetriesStrategies: QueryRetriesStrategies = {
  retryTimeout: (failureCount, error) => {
    if (error instanceof TimeoutError) {
      return true; // always retry on TimeoutError
    }
    return failureCount < 5; // retry at most 5 times
  },
};
